import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";
import {DescriptionHeaderStaticViewModel} from "../../../core/components/description-header/models/description-header.static.view-model";

export class CatalogRouteMetaDataModel extends BaseRouteMetaDataModel {

  get pageTitle() {
    return this.termsUtils.terms.COMPETITION_CATALOGUE_TITLE_TEMPLATE;
  }

  get description() {
    return this.termsUtils.terms.COMPETITION_CATALOGUE_DESCRIPTION_TEMPLATE;
  }

  get entity() {
    const entity = new DescriptionHeaderStaticViewModel(null, this.headerTitle, this.headerDescription);

    return entity;
  }

  get headerTitle() {
    return this.termsUtils.terms.WEB_LEAGUE_CATALOG_INPAGE_TITLE;
  }

  get headerDescription() {
    return this.termsUtils.terms.WEB_LEAGUES_CATALOG_DESCIPTION;
  }
}
